const SYMBOL = '$'; // Only USD is supported for now.
const SEPARATOR_LENGTH = 1;
const FRACTION_DIGITS_LENGTH = 2;
const LARGE_NUMBER_THRESHOLD = 1000;

const formatter = new Intl.NumberFormat('en-US', {
  style: 'decimal',
  minimumFractionDigits: FRACTION_DIGITS_LENGTH,
  maximumFractionDigits: FRACTION_DIGITS_LENGTH,
});

const largeNumberFormatter = new Intl.NumberFormat('en-US', {
  style: 'decimal',
  minimumFractionDigits: 0,
  maximumFractionDigits: 1,
  // @ts-expect-error roundingMode exists on NumberFormatOptions, but is not part of the TypeScript definition
  roundingMode: 'floor',
});

const symbolByExponent = {
  3: 'K',
  6: 'M',
  9: 'B',
  12: 'T',
};

export function formatValue(value: number | null) {
  if (value === null) {
    return {
      symbol: SYMBOL,
      integerDigits: '-',
      fractionDigits: `.${'-'.repeat(FRACTION_DIGITS_LENGTH)}`,
    };
  }

  if (value >= LARGE_NUMBER_THRESHOLD) {
    const exp = Math.log10(value);
    const divisorExp = exp - (exp % 3);
    const symbol = symbolByExponent[divisorExp] ?? '';
    const formatted = largeNumberFormatter.format(
      value / Math.pow(10, divisorExp),
    );

    return {
      symbol: SYMBOL,
      integerDigits: `${formatted}${symbol}`,
    };
  }

  const formattedValue = formatter.format(value);
  const [integerDigits, fractionDigits] = [
    formattedValue.slice(0, -FRACTION_DIGITS_LENGTH - SEPARATOR_LENGTH),
    formattedValue.slice(-FRACTION_DIGITS_LENGTH - SEPARATOR_LENGTH),
  ];
  return { symbol: SYMBOL, integerDigits, fractionDigits };
}
